export default "__VITE_ASSET__Bj3Zo3WX__"